// import logo from './logo.svg';
import './App.css';
import Content from './Layouts/content';
function App() {
  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <Content />
  );
}
export default App;